// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isDesignerOnline(lastSeenAt: any) {
    return Math.round((Date.now() - Date.parse(lastSeenAt)) / (60 * 1000)) <= 20;
}
